export default {
    props: {
        formData: Object,
        integration: Object,
        requiredFields: Array,
    },

    data() {
        return {
            config: this.$inertia.form(this.formData),
        };
    },

    methods: {
        saveUserSettings() {
            this.config.post(this.$route('integration.config', this.integration.code));
        },
    }
};
